export type CTraderCommandParameters = {
    clientMsgId: string;
};
